import { css } from '@emotion/core';

export default css`
  #overlay-root > div:not(:last-of-type) {
    display: none;
  }
  .data-layer {
    z-index: 2;
  }
  #g_a11y_announcement {
    left: -10000px;
    right: auto;
  }
  div.mapboxgl-popup-content {
    box-shadow: none;
    background-color: rgba(255, 255, 255, 0);
    box-sizing: border-box;
    padding: 0;
  }
  div.mapboxgl-popup-tip {
    display: none !important;
  }
`;
